export function spriteUrl(item: { UUID: string }, contentCdnUrl: string, siteUUID: string, isFull = false) {
  return `${contentCdnUrl}/${siteUUID}/media/${item.UUID}/${isFull ? 'full_' : ''}sprite_${item.UUID}-48.jpg`;
}
